module.exports = __webpack_public_path__ + "assets/img/travel-day35.5e07ae1d.png";